import { ProductBrandListPage } from "@/features/product-brand/pages/ProductBrandListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-brand/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_brand.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductBrandListPage,
});
